import { impersonateApis } from '@apis/impersonateApis';
import { useMutation } from '@hooks/useMutation';
import { AuthManager } from '@store/AuthManager';
import { useQueryClient } from '@tanstack/react-query';
import { FormError } from '@utils/errors';
// import { AuthManager } from '@store/AuthManager';

export const useImpersonate = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async (path: { id: number }) => {
      const response = await impersonateApis.get('/impersonate/{id}/', { path });
      if (response[403]) {
        throw new FormError('ImpersonateError', response[403]);
      }
      return response[200]!;
    },
    {
      onSuccess: (data) => {
        AuthManager.shared.setImpersonatedUser(data.impersonate_id);
        AuthManager.shared.setOriginalUser(data.original_user_id);

        queryClient.removeQueries();
      },
    },
  );
};
